import { connect } from 'react-redux';
import { requestToggleFullscreenView } from '../../../DeviationPage/redux/actions';
import { getIsFullscreenAllowed } from '../../../DeviationPage/redux/selectors';
const mapStateToProps = (state, { deviation  })=>({
        canFullscreen: getIsFullscreenAllowed(state)
    });
const mapDispatchToProps = {
    onClick: requestToggleFullscreenView
};
export default connect(mapStateToProps, mapDispatchToProps);
